export const ensurePair = (v: any): [number, number] => {
  if (Array.isArray(v) && v.length >= 2) {
    return [Number(v[0]) || 0, Number(v[1]) || 0];
  }
  if (typeof v === "string" && v.includes(":")) {
    const [a, b] = v.split(":");
    return [Number(a) || 0, Number(b) || 0];
  }
  return [0, 0];
};

export const extractFirstNonZero = (
  parts: string[],
  keys: string[]
): [number, number] | null => {
  for (const k of keys) {
    const needle = `${k}=`;
    const hit = parts.find((p) => p.trim().startsWith(needle));
    if (hit) {
      const raw = hit.slice(needle.length).trim();
      const pair = ensurePair(raw);
      if (pair[0] !== 0 || pair[1] !== 0) return pair;
      return pair;
    }
  }
  return null;
};
